// extracted by mini-css-extract-plugin
export default {"Reviews":"style_Reviews__-Wm1p"};